import { fetcher } from "./gameserver";

export const getPlayerDetails = async (game, id, auth) => {
  const method = "GET";
  return fetcher(
    { method, subject: "player" },
    auth
  )(`/games/${game}/players/${id}`);
};
